import React, {Component} from 'react';
import "./RaikoInputStyleSheet.css"
import {useState} from "react";
import {IconButton, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";

const RaikoMaterialOutlinedPasswordInput = ({
                                                labelText,
                                                placeHolder,
                                                value,
                                                onChange,
                                                spellCheck = true,
                                                inputId,
                                                onKeyUp
                                            }) => {

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <InputLabel htmlFor={inputId}>{labelText}</InputLabel>
            <OutlinedInput
                id={inputId}
                type={showPassword ? 'text' : 'password'}
                value={value}
                spellCheck={spellCheck}
                placeholder={placeHolder}
                onChange={onChange}
                onKeyUp={onKeyUp}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            <div className={showPassword ? "ic-password-invisible" : "ic-password-visible"}/>
                        </IconButton>
                    </InputAdornment>
                }
                label={labelText}
            />
        </>
    )

}

export default RaikoMaterialOutlinedPasswordInput;